import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { CommunicationType } from './communication-type.interface';

export class CommunicationTypeService {
   async getCommunicationTypes(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<CommunicationType>>>(`/communication-types`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }
}
